import React, { Component } from 'react';
import Routes from './Router';
import Script from 'react-load-script';
import { Link } from 'react-router-dom';
import { Dropdown, Button, ButtonGroup } from 'react-bootstrap';

import ls from 'local-storage';
import Swal from 'sweetalert2'
import $ from 'jquery';

export class Layout extends Component {
    static displayName = Layout.name;
  
    constructor(props) {
        super(props);
        this.state = { teamList: [], currentTeam: ls.get('currentTeam') || "0", teamName: "Teams" , needsTeam:false};
        this.refresh = this.refresh.bind(this);
        this.signout = this.signout.bind(this);
        this.onTeamSelect = this.onTeamSelect.bind(this);
        this.getTeamList = this.getTeamList.bind(this);
       
    }
    getTeamList = async (teamidP =null) => {
        var teamid = "";
      
        if (teamidP === null) {          
            teamid = ls.get('currentTeam') || '0';           
        
        }
        else {
        
            ls.set('currentTeam', teamidP); 
            teamid = teamidP;
        }
        const resp = await fetch('api/team/teamlist', {
            method: 'GET',
            credentials: 'same-origin'
        });
       
        if (resp.status === 200) {

            try {
                const jdata = await resp.json();

                if (this._isMounted) {
                    const teamSortByName = jdata.teams.sort(function (a, b) { if (a.name < b.name) return -1; if (a.name > b.name) return 1; return 0 })
                    await this.setState({ teamList: teamSortByName, teamMessage: this.state.teamList.length > 0 ? "" : "No Teams" });

                    if (this.state.teamList.length === 0) {
                        

                        ls.remove('currentTeam');
                        await this.setState({ needsTeam: true, teamName:"No Teams"});
                       
                    }
                    else {
                        await this.setState({ needsTeam: false });
                        var listChk = this.state.teamList.filter(team => team.id === teamid)[0];

                        if (listChk === undefined || listChk === null) {

                            ls.remove('currentTeam');
                            teamid = '0';
                        }


                        if (teamid !== '0') {

                            await this.setState({ currentTeam: teamid });
                            this.setState({ teamName: listChk.name });
                        }
                        else {
                            await this.setState({ currentTeam: this.state.teamList[0].id });
                            this.setState({ teamName: this.state.teamList[0].name });
                        }
                    }
                

                }

            } catch (e) {
                console.log(resp.statusText);

                this.setState({ message: '500: Check console' })
            }
        }
        else if (resp.status === 401) {
            this.setState({ message: '401: Not Authorized' })
        }
        else {
            this.setState({ message: 'There was a problem, please try again later' });
        }
      
    }

   
    onTeamSelect(eventKey, e) {
        if (eventKey !== null) {
            this.setState({ currentTeam: eventKey });   
          
            this.setState({ teamName: this.state.teamList.filter(team => team.id === eventKey)[0].name});
             ls.set('currentTeam', eventKey); 
        }
       
    }
   
    componentDidMount() {
     
        this._isMounted = true;
          (async () => {
            this.getTeamList()
        })();
      
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.teamList !== prevState.teamList && this.state.teamList.length) {  
            if (this.state.teamList.filter(team => team.id === this.state.currentTeam).length) {
                this.setState({ teamName: this.state.teamList.filter(team => team.id === this.state.currentTeam)[0].name });
            }
        }
    }
    handleScriptCreate() {
        this.setState({
            scriptLoaded: false
        })
    }
    handleScriptError(e) {
        this.setState({
            scriptError: true
        })
        console.log(e)
    }
    handleScriptLoad() {
        this.setState({
            scriptLoaded: true
        })
    }
    logout = async () => {
        Swal.fire({
            title: 'Logout',
            text: 'Are you sure you want to logout?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, log me out!',
            cancelButtonText: 'No, stay logged in.'
        }).then((result) => {
            if (result.value) {
                this.signout();
            } else if (result.dismiss === Swal.DismissReason.cancel) {
               
            }
        })
    }

    refresh() {
        this.props.refreshUser();
        this.getTeamList();
    }
    async signout() {
        const resp =
            await fetch('api/auth/signout', {
                method: 'POST',
                credentials: 'same-origin'

            });

        if (resp.status === 200) {
           
           
            await this.props.refreshUser();
            //this.props.history.push("/");
            //Cant access this here so going with reload for now
            window.location.reload(false);
        }
        else {
            const jdata = await resp.json();
            console.log(jdata.status + ' ' + jdata.message);
        }
    }
 

    render() {
        const userInfo = this.props;
        const CDN = window.CDN;
        const status = userInfo.auth ? (<Link to="#" onClick={() => this.logout()} className="text-mute text-capitalize">
            <i className="fas fa-sign-out-alt"></i> <span> Sign Out</span>
        </Link>
        ) : ("");
      
   
        const teamNameDropdown = this.state.teamName;
        const teamItems = this.state.teamList.length > 0 ? this.state.teamList.map((team) =>
            <Dropdown.Item as="button" key={team.id} eventKey={team.id}>{team.name}</Dropdown.Item>) : ""
        return (
            
            <div>
                <Script
                    url="/js/sideBarSetup.js"
                    onCreate={this.handleScriptCreate.bind(this)}
                    onError={this.handleScriptError.bind(this)}
                    onLoad={this.handleScriptLoad.bind(this)}
                />
                <Script
                    url="/js/main.js"
                    onCreate={this.handleScriptCreate.bind(this)}
                    onError={this.handleScriptError.bind(this)}
                    onLoad={this.handleScriptLoad.bind(this)}
                />


                <div className="page-wrapper default-theme sidebar-bg toggled">
                    <div className="top-menu-offset row"></div>
                    <div id="brandImageContainer">
                        <div className="row">
                            <div className="col-xs-5 brand-left">
                                <a href="/home" className="brand-img">
                                    <img src={ CDN.replace("{0}", "/img/logo.png") } height="70" alt="" />
                                </a>
                            </div>
                            <div className="col-xs-5">
                                <nav className="navbar navbar-light">
                                    <a id="toggle-sidebar" className="p-0 navbar-toggler btn btn-secondary rounded-0">
                                        <i className="icon fa fa-caret-left pull-left"></i>
                                        <span className="navbar-toggler-icon"></span>
                                    </a>
                                   
                                </nav>
                            </div>
                            {/*(<div className="col-xs-2 ">
                                <select className="mt10 form-control" onChange={e => this.onTeamChange(e)} value={this.state.currentTeam}>
                                    <option key={0} value={0} >Pick a Team</option>
                                    {teamOptions}
                                </select>
                            </div>*/}
                            <div>


                                <Dropdown as={ButtonGroup}
                                    variant="light"
                                    className="mt10 btn-team btn-label-group"
                                    id="dropdown-item-button"
                                    onSelect={(eventKey, e) => this.onTeamSelect(eventKey, e)}
                                    
                                >
                                    <Button variant="light" className="pr0 btn-nohover">Team</Button>
                                    <Button variant="light" className="pl0 btn-label">{teamNameDropdown}</Button>

                                    <Dropdown.Toggle split variant="light" id="dropdown-split-basic" />

                                    <Dropdown.Menu>
                                        <Dropdown.Item as="button" key="1"><Link to="/teams">Create New Team </Link></Dropdown.Item>
                                        <Dropdown.Divider />

                                        {teamItems}
                                    </Dropdown.Menu>
                                </Dropdown>

                            </div>
                        </div>
                    </div>
                    <nav id="sidebar" className="sidebar-wrapper">
                        <div className="sidebar-content" style={{ overflow: 'hidden' }}>
                            <div className="sidebar-item sidebar-header d-flex flex-nowrap">
                                <div className="user-pic">
                                    <img className="img-responsive img-rounded" src={userInfo.picUrl} alt=""></img>
                                </div>
                                <div className="user-info">
                                    <span className="user-name">
                                        {userInfo.name}
                                    </span>

                                    <span className="user-name">
                                        {status}
                                    </span>
                                </div>
                            </div>

                            <div className="sidebar-item sidebar-menu">
                                <ul className="mt-3">

                                    <li>
                                        <Link to="/lists">
                                            <i className="fa fa-list"></i>
                                            <span className="menu-text">Collections</span>
                                        </Link>
                                    </li>

                                    <li>
                                        <Link to="/teams">
                                            <i className="fa fa-users"></i>
                                            <span className="menu-text">Teams</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/billing">
                                            <i className="fa fa-credit-card"></i>
                                            <span className="menu-text">Billing</span>
                                        </Link>
                                    </li>
                                    
                                </ul>
                            </div>
                        </div>
                    </nav>

                    <main className="page-content pt-2">
                        <div className="container">
                            <Routes authed={this.props.auth} currentTeam={this.state.currentTeam} needsTeam={ this.state.needsTeam} onTeamListChange={this.getTeamList} refreshUI={this.refresh} showBusy={this.props.showBusy}/>
                           
                        </div>
                        <div id="overlay" className="overlay"></div>
                        <div className="container-fluid p-5">
                            <div className="row">
                                <div className="col-md-12"></div>
                            </div>
                        </div>
                      
                    </main>
                </div>

       

                <Script url="">
                    $(document).ready(function{
                        $(document).on("click", ".sidebar-menu ul li", function () {
                            $(".sidebar-menu ul li").removeClass("active");
                            $(this).addClass("active");
                        })
                });
                </Script>

            </div>
        );
    }
}
